import api from '../../api/moviedb';
import * as types from '../mutation-types';

const state = {
  query: null,
  movies: [],
  searched: false,
};

const mutations = {
  [types.SET_SEARCH_MOVIES](state, movies) {
    state.movies = movies;
  },
  [types.SET_SEARCH_QUERY](state, query) {
    state.query = query;
  },
  [types.REMOVE_UNUSED_MOVIES](state, movie) {
    state.movies = [movie];
  },
  [types.SET_STATUS_SEARCHED](state) {
    state.searched = true;
  },
};

const actions = {
  searchMovie: ({ commit }, query) => {
    commit(types.SET_SEARCH_QUERY, query);
    api.getSearchedMovie(query, (movies) => {
      commit(types.SET_SEARCH_MOVIES, movies);
      commit(types.SET_STATUS_SEARCHED);
    });
  },
  removeUnusedMovies: ({ commit }, searchedMovie) => {
    commit(types.REMOVE_UNUSED_MOVIES, searchedMovie);
  },
};

const getters = {
  searchedMovies(state) {
    return state.movies.slice(0, 3);
  },
  queryFailed(state) {
    return (state.movies.length === 0 && state.searched);
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
